import { Outlet, createRootRouteWithContext } from '@tanstack/react-router'
import type { QueryClient } from '@tanstack/react-query'

import { useCrumbs } from '@/app/use-crumbs'
import { AuthProvider } from '@/auth/auth-provider'
import { ConfirmProvider } from '@/components/kit/actions'
import { Toaster } from '@/components/ui/sonner'
import { useDocumentTitle } from '@/hooks/use-document-title'

export interface RouterContext {
    queryClient: QueryClient
}

export const Route = createRootRouteWithContext<RouterContext>()({
    component: RootLayout
})

/**
 * `AuthProvider` lives here rather than in main.tsx because it needs the router's
 * navigate to redirect on a 401, and the router is not available above
 * `RouterProvider`.
 *
 * `ConfirmProvider` is at the root so `useConfirm()` resolves from any route,
 * including the login page's own destructive paths.
 *
 * The tab title is set here rather than in the shell so the login page gets one too,
 * instead of keeping whatever the last page behind the session left in it.
 */
function RootLayout() {
    useDocumentTitle(useCrumbs().map(crumb => crumb.label))

    return (
        <AuthProvider>
            <ConfirmProvider>
                <Outlet />
                <Toaster />
            </ConfirmProvider>
        </AuthProvider>
    )
}
